import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import HomePage from "./pages/home/HomePage";
import { PagePlaceholder } from "./components/PagePlaceholder";

const LicensePage = lazy(() => import("./pages/License"));
const CyberRunnerPage = lazy(() => import("./pages/CyberRunner"));
const GalleryPage = lazy(() => import("./pages/gallery"));
const NotFoundPage = lazy(() => import("./pages/not-found/NotFoundPage"));

const PageFallback = () => <PagePlaceholder />;

const LazyRoute = ({
  component: Component,
}: {
  component: React.ComponentType;
}) => (
  <Suspense fallback={<PageFallback />}>
    <Component />
  </Suspense>
);

const App = (): JSX.Element => {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <HomePage />
        </Route>
        <Route exact path="/license">
          <LazyRoute component={LicensePage} />
        </Route>
        <Route exact path="/cyber-run">
          <LazyRoute component={CyberRunnerPage} />
        </Route>
        <Route path="/gallery/:id?">
          <LazyRoute component={GalleryPage} />
        </Route>
        <Route>
          <LazyRoute component={NotFoundPage} />
        </Route>
      </Switch>
    </Router>
  );
};

export default App;
